module.exports = __webpack_public_path__ + "img/logo.d17f418e.png";